export default __webpack_public_path__ + "f4e241b4bd4de786b15219547a9a4cb9.svg";